import { render, staticRenderFns } from "./tambah_projek.vue?vue&type=template&id=d15a957e"
import script from "./tambah_projek.vue?vue&type=script&lang=js"
export * from "./tambah_projek.vue?vue&type=script&lang=js"
import style0 from "./tambah_projek.vue?vue&type=style&index=0&id=d15a957e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports